<template>
  <div class="index">
    <!--<index>-->
    <Header class="layoutHeader">
      <div class="HeaderLeft">
        <ul>
          <li><img :src="schoolLogo" style="width: .45rem;height: .45rem;margin-top: .14rem;border-radius: .1rem"></li>
          <li style="margin-left: .16rem">{{ schoolName }}</li>
          <li style="margin: 0 .10rem">丨</li>
          <li style="font-size: .18rem">平安校园管理系统</li>
        </ul>
      </div>
      <div class="HeaderRight">
        <ul>
          <li>
            <a @click="goToHome" style="color: #fff">首页</a>
          </li>
          <li><img :src="userIcon" class="userIcon"></li>
          <li style="margin-left: 0.08rem">{{ userName }}</li>
          <li><img src="./exit.png" style=" width: .16rem;height: .16rem;line-height: .72rem;
          position: relative;left: 2px;top: 2px;"></li>
          <li style="margin-left: 0.05rem; cursor: pointer" @click="logout">退出</li>
        </ul>
      </div>
    </Header>
    <router-view></router-view>
  </div>
</template>

<script>
import {getCookie, goToHome, clearAllCookie} from '@/common/js/cookie'
import {getUserInfo} from '@/api/api'
export default {
  name: 'index',
  mounted () {
    this.init()
  },
  data () {
    return {
      type: false,
      type1: false,
      routes: [],
      schoolLogo: '',
      schoolName: '',
      userIcon: '',
      userName: ''
    }
  },
  methods: {
    // 获取学校信息和用户信息
    async init () {
      this.schoolLogo = getCookie('schoolLogo')
      this.schoolName = getCookie('schoolName')
      this.userIcon = getCookie('userIcon')
      this.userName = getCookie('userName')
      // 验证是否有权限
      await getUserInfo()
    },
    goToHome () {
      goToHome()
    },
    logout () {
      this.$Modal.confirm({
        title: '提示',
        content: '确认退出吗？',
        onOk: () => {
          clearAllCookie()
          this.$Message.info('退出成功')
        },
        onCancel: () => {
          this.$Message.info('取消退出')
        }
      })
    },
    changePicture () {
      this.type = !this.type
    },
    changePicture1 () {
      this.type1 = !this.type1
    }
  }
}
</script>

<style scoped>
  .index {
    height: 100%;
  }
  .layoutHeader {
    background-color: #15bc41;
    height: 0.72rem;
    overflow: hidden;
    width: 100%;
  }

  .HeaderLeft {
    line-height: .72rem;
    float: left;
  }

  .HeaderLeft ul li {
    display: inline;
    float: left;
    font-size: .26rem;
    color: #fff;
  }
  .HeaderRight {
    float: right;
    padding: 0;
    margin-top: -0.05rem;
  }
  .HeaderRight ul li {
    display: inline;
    font-size: .16rem;
    margin-left: .2rem;
    color: #fff;
  }

  .userIcon {
    width: .46rem;
    height: .46rem;
    border-radius: 50%;
    line-height: .72rem;
    position: relative;
    top: .18rem;
  }
  .logo img {
    width: .45rem;
    height: .45rem;
    margin-bottom: 0.8rem;
  }

  .Fixed li {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue